<template>
  <div
    class="d-flex align-center"
    :class="{ 'checkbox-disabled': disabled, readonly }"
  >
    <div class="d-flex justify-center">
      <img
        class="c-checkbox-main"
        :width="width"
        :height="height"
        :src="checkboxImage"
        @click="click"
      />
    </div>
    <div v-if="label" class="c-checkbox-label" @click="click">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      default: () => "",
    },
    width: {
      type: String,
      default: () => "18px",
    },
    height: {
      type: String,
      default: () => "18px",
    },
    align: {
      type: String,
      default: () => "center",
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    checkboxImageOptions: {
      type: Object,
      default: () => {
        return {
          disabled: "/img/checkbox-half-disabled.svg",
          selected: "/img/checkbox-half-filled.svg",
          default: "/img/checkbox-half-empty.svg",
        };
      },
    },
  },
  data: () => {
    return {
      selected: false,
    };
  },
  watch: {
    value() {
      if (this.disabled) return;

      this.selected = this.value;
    },
    disabled() {
      this.selected = this.value;
    },
  },
  mounted() {
    this.selected = this.value;
  },
  computed: {
    checkboxImage() {
      if (this.disabled) {
        return this.checkboxImageOptions.disabled;
      }

      if (this.readonly && this.selected) {
        return `/img/checkbox_readonly_checked.svg`;
      }

      if (this.selected) {
        return this.checkboxImageOptions.selected;
      }

      return this.checkboxImageOptions.default;
    },
  },
  methods: {
    click() {
      if (this.readonly) {
        return;
      }

      this.selected = !this.selected;
      this.$emit("input", this.selected);
      this.$emit("click", this.selected);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-checkbox-main {
  cursor: pointer;
}

.c-checkbox-label {
  cursor: pointer;
  margin-left: 5px;
  padding-top: 2px;
  min-width: 100%;
  user-select: none;
}

.readonly {
  opacity: 0.5;
  cursor: not-allowed;
}

.checkbox-disabled {
  pointer-events: none;
}

.checkbox-disabled > * {
  color: #999;
}
</style>
